import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { DomainHierarchyResponse } from '@/entities/domain/domain';

type GetDomainHierarchyParams = {
  limit?: number;
};

export const getDomainHierarchyApi = async ({
  limit = 3000,
}: GetDomainHierarchyParams = {}): Promise<DomainHierarchyResponse> => {
  try {
    const response = await openMetadataApiClient.get<DomainHierarchyResponse>('/domains/hierarchy', {
      params: {
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch domain hierarchy:', error);
    throw error;
  }
};
